import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import moment from 'moment-timezone';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import CsvDownloadButton from '../../components/atoms/CsvDownloadButton';
import ShopRegisterButton from '../../components/atoms/ShopRegisterButton';
import StepBackButton from '../../components/atoms/StepBackButton';
import ShopTableShop from '../organisms/ShopTableShop';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getShops, downloadShop, getShopDetail } from '../../actions/Shop';
import { getAccounts } from '../../actions/Accounts';
import ShopAddAdmin from '../organisms/ShopAddAdmin';
import MenuBox from '../../components/MenuBox';
// import ShopDetailShop from '../organisms/ShopDetailShop';

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 20,
    textAlign: 'left',
    backgroundColor: '#F7F7F7',
    fontSize: '24 !important'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  button: {
    margin: '5px 5px'
  },
  buttonLeft: {
    textAlign: 'left'
    // CSV出力ボタンを実装時にコメントアウトを外す
    // float: 'left'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonGroupRight: {
    textAlign: 'right'
  },
  textTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: 'rgba(0, 0, 0, 0.87)'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      shops: state.shops.shops,
      identityStatuses: state.identities.statuses,
      shopStatuses: state.shops.shopStatuses
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getShops, downloadShop, getAccounts, getShopDetail },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openShopAdd', 'updateOpenShopAdd', false),
  withState('openShopAddConfirm', 'updateOpenShopAddConfirm', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopName', 'setShopName', ''),
  withState('groupName', 'setGroupName', ''),
  withState('address', 'setAddress', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('identityStatus', 'setIdentityStatus', ''),
  withState('shopStatus', 'setShopStatus', ''),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('groupDepositManage', 'setGroupDepositManage', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('shopNameKana', 'setShopNameKana', ''),
  withState('countryCode', 'setCountryCode', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefectures', 'setPrefectures', ''),
  withState('city', 'setCity', ''),
  withState('address', 'setAddress', ''),
  withState('building', 'setBuilding', ''),
  withState('shopGroupName', 'setShopGroupName', ''),
  withState('shopContactName', 'setShopContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('contactPhone', 'setContactPhone', ''),
  withState('phone', 'setPhone', ''),
  withState('introduction', 'setIntroduction', ''),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('nearestStation', 'setNearestStation', ''),
  withState('priceRange', 'setPriceRange', ''),
  withState('access', 'setAccess', ''),
  withState('webPage', 'setWebPage', ''),
  withState('tags', 'setTags', []),
  withState('tagStr', 'setTagStr', ''),
  withState('images', 'setImages', []),
  withState('shopAnniversaries', 'setShopAnniversaries', []),
  withState('status', 'setStatus', ''),
  withState('statusStr', 'setStatusStr', ''),
  withState('stealthMode', 'setStealthMode', ''),
  withState('stealthModeStr', 'setStealthModeStr', ''),
  withState('gochiRestriction', 'setGochiRestriction', ''),
  withState('gochiRestrictionStr', 'setGochiRestrictionStr', ''),
  withState('depositManage', 'setDepositManage', 'NONSELF'),
  withState('depositManageStr', 'setDepositManageStr', '入金を自身で管理する'),
  withState('bankName', 'setBankName', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('inviteUserId', 'setInviteUserId', 0),
  withState('inviteUserStr', 'setInviteUserStr', ''),
  withState('cognitoUserId', 'setCognitoUserId', ''),
  withState('email', 'setEmail', ''),
  withState('bankSwitchable', 'setBankSwitchable', true),
  withState('createdAt', 'setCreatedAt', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('shopCategoryId', 'setShopCategoryId', 0),
  withState('numberSit', 'setNumberSit', ''),
  withState('smoking', 'setSmoking', ''),
  withState('parking', 'setParking', ''),
  withState('snsFacebook', 'setSnsFacebook', ''),
  withState('snsTwitter', 'setSnsTwitter', ''),
  withState('snsInstagram', 'setSnsInstagram', ''),
  withState('page', 'setPage', 1),
  withState('showPhone', 'setShowPhone', 1),
  withState('childShopFlag', 'setChildShopFlag', 0),
  withState('accountStatus', 'setAccountStatus', 1),
  withState('statusShop', 'setStatusShop', 'AVAILABLE'),
  withState('message', 'setMessage', ''),
  withState('paymentGroupType', 'setPaymentGroupType', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      props.setPage(page);
      if (table !== null) {
        table.scrollTop = 0;
      }
      const searchKey = {
        shopName: props.shopName,
        groupName: props.groupName,
        address: props.address,
        identityStatus: props.identityStatus,
        shopStatus: props.shopStatus,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getShops(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);

        const searchShopId = queryString.parse(this.props.location.search)
          .shopId;
        if (data.payload.role === 'SHOP') {
          this.props.actions
            .getShops({
              page: this.props.page,
              limit: this.props.rowsPerPage
            })
            .then(shopData => this.props.checkSession(shopData));
          this.props.updateOpenTable(true);
        } else if (searchShopId) {
          await this.props.actions
            .getShops({
              shopId: searchShopId,
              page: this.props.page,
              limit: this.props.rowsPerPage
            })
            .then(shopData => {
              this.props.checkSession(shopData);
              this.props.setShopName(shopData.payload.shops[0].shopName);
            });
          this.props.updateOpenTable(true);
        }
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    account,
    checkSession,
    handleRedirect,
    handleChangePage,
    openDrawer,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    openShopAdd,
    updateOpenShopAdd,
    openShopAddConfirm,
    updateOpenShopAddConfirm,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    shopName,
    setShopName,
    groupName,
    setGroupName,
    address,
    setAddress,
    page,
    identityStatuses,
    identityStatus,
    setIdentityStatus,
    shopStatuses,
    shopStatus,
    setShopStatus,
    rowsPerPage
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;
    const educateSystem =
      typeof account !== 'undefined' && account.educateSystem;
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      resultMessage,
      setResultMessage
    };

    // const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      shopName,
      groupName,
      address,
      identityStatus,
      shopStatus,
      page,
      limit: limitNum
    };

    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, limitNum);
    };

    const downloadCsvBlob = (blob, fileName) => {
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(new Blob([blob], { type: 'text/csv' }));
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();
        linkEl.parentNode.removeChild(linkEl);
        // iOSのクリックイベント対策
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const csvDownloadAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .downloadShop(searchKey)
        .then(data => checkSession(data));
      if (response.type === 'DOWNLOAD_SHOP_SUCCESS') {
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        updateOpenProgress(false);
        setResultMessage('');
        updateLoading(false);
        downloadCsvBlob(response.payload, `${timeStamp}_shop_info.csv`);
      } else {
        setResultMessage('店舗情報ダウンロードに失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const registerOpenAction = () => updateOpenShopAdd(true);
    const shopCancelAction = () => updateOpenShopAdd(false);
    const shopBackAction = () => updateOpenShopAddConfirm(false);
    const backAction = () => handleRedirect('/release_step');
    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography className={classes.textTitle}>
            {isFukuoka ? '教室情報管理' : '店舗情報管理'}
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          {/* <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={detailOpenAction}
          >
            Detail 5798
          </Button> */}
          <div className={classes.searchForm}>
            <div>
              {(roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="運営会社名"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={groupName}
                  onChange={e => {
                    setGroupName(e.target.value);
                  }}
                />
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  select
                  label="審査状況"
                  className={classes.textField}
                  margin="normal"
                  value={identityStatus}
                  onChange={e => {
                    setIdentityStatus(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                >
                  {identityStatuses.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  select
                  label="開店状況"
                  className={classes.textField}
                  margin="normal"
                  value={shopStatus}
                  onChange={e => {
                    setShopStatus(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                >
                  {shopStatuses.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              )}
            </div>
            <div>
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="店舗名"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={shopName}
                  onChange={e => {
                    setShopName(e.target.value);
                  }}
                />
              )}
              {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
                <TextField
                  label="住所"
                  placeholder="部分一致"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={address}
                  onChange={e => {
                    setAddress(e.target.value);
                  }}
                />
              )}
            </div>
            {(roles.isSecretariat || roles.isDeveloper) && (
              <div>
                <div className={classes.buttonGroupLeft}>
                  <SearchButton onClickAction={searchAction} />
                </div>
                <div className={classes.buttonGroupRight}>
                  <ShopRegisterButton onClickAction={registerOpenAction} />
                  <CsvDownloadButton onClickAction={csvDownloadAction} />
                </div>
              </div>
            )}
            {roles.isGroup && (
              <div>
                <SearchButton onClickAction={searchAction} />
              </div>
            )}
          </div>
          {openTable && (
            <ShopTableShop
              roles={roles}
              progress={progress}
              searchKey={searchKey}
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
              isFukuoka={isFukuoka}
              educateSystem={educateSystem}
            />
          )}
          {isShop && !isReleased && (
            <div>
              <StepBackButton onClickAction={backAction} />
            </div>
          )}
        </Paper>

        {/* <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
          className={classes.modalMobile}
        >
          <ShopDetailShop
            updateOpenDetailModal={updateOpenDetailModal}
            detail={detail}
          />
        </Modal> */}
        <div>
          <Modal open={openShopAdd}>
            <ShopAddAdmin
              openShopAddConfirm={openShopAddConfirm}
              updateOpenShopAdd={updateOpenShopAdd}
              updateOpenShopAddConfirm={updateOpenShopAddConfirm}
              cancelAction={shopCancelAction}
              backAction={shopBackAction}
              searchKey={searchKey}
            />
          </Modal>
        </div>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <MenuBox account={account} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
